import { Container } from '../styled';
export function VisuallyHidden(props) {
    const { children } = props;
    return <Container>{children}</Container>;
}
